import React from 'react'

/**
 * @param withBackground: Boolean = false
 * @param large: Boolean = false
 */
class Spinner extends React.Component
{

    render()
    {
        const spinner = (style, className) => (
            <div style={style} className={"lds-spinner" + (this.props.large ? " large" : "") + (className || "")}><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div>
        )

        return this.props.withBackground ? (
            <div style={ this.props.style } className={ "lds-spinner-container " + (this.props.className || "") }>{ spinner() }</div>
        ) : spinner(this.props.style, this.props.className)
    }

}

export { Spinner }
export default Spinner